const axios = require("axios");
import Vue from "vue";
const _ = require("lodash");
import { stringify } from "querystring";
import querystring from "querystring";

let loadingInstance;
function HandleLoading(callback) {
  return callback();
}

class API {
  constructor() {
    this._token = "";
    this._baseURL = "";
  }

  set baseURL(url) {
    this._baseURL = url;
  }

  get baseURL() {
    return this._baseURL;
  }

  set token(token) {
    let $bus = new Vue().$bus;
    this._token = token;
    this._instance = axios.create({
      baseURL: this._baseURL,
      headers: { Authorization: token },
    });
    this._instance.interceptors.response.use(
      (res) => {
        return res;
      },
      (e) => {
        let res = e.response || { data: { message: "unknown" } };
        if (
          res &&
          res.status == 403 &&
          res.data.message.match("找不到此帳號")
        ) {
          console.log(res.data.message);
          $bus.$emit("userTokenError", { e });
          // $bus.$emit("UnexpectedError", { e });
        }
        return Promise.reject(e);
      }
    );
  }

  //User
  SignUp(data) {
    return HandleLoading(() => this._instance.post("/api/auth/sign-up", data));
  }

  RegisterProfile(data) {
    return HandleLoading(() =>
      this._instance.post("/api/auth/profile/new", data)
    );
  }

  FetchUserInfo() {
    return HandleLoading(() => this._instance.get("/api/auth"));
  }

  Login(data) {
    return HandleLoading(() => this._instance.post("/api/auth/login", data));
  }

  UpdatePersonBasicProfile(data) {
    return HandleLoading(() =>
      this._instance.put("/api/auth/profile/basic", data)
    );
  }

  NewPersonJob(data) {
    return HandleLoading(() =>
      this._instance.post(`/api/auth/profile/jobs`, data)
    );
  }

  UpdatePersonJob(data) {
    return HandleLoading(() =>
      this._instance.put(
        `/api/auth/profile/jobs/${data.id ? data.id : ""}`,
        data
      )
    );
  }

  DeletePersonJob(id) {
    return HandleLoading(() =>
      this._instance.delete(`/api/auth/profile/jobs/${id}`)
    );
  }

  ChangePassword(data) {
    return HandleLoading(() =>
      this._instance.put("/api/auth/reset/password", data)
    );
  }

  ForgetPassword(data) {
    return HandleLoading(() =>
      this._instance.post("/api/auth/reset/email", data)
    );
  }

  GetSchool(data) {
    return HandleLoading(() =>
      this._instance.get(
        `/api/school/filter?category=${data.category}&city=${data.city}&district=${data.district}`
      )
    );
  }

  //Story
  SearchAccount(data) {
    return HandleLoading(() =>
      this._instance.post("/api/auth/search/user", data)
    );
  }

  CreateStory(data) {
    return HandleLoading(() => this._instance.post("/api/story/create", data));
  }

  GetPersonStoryList(data) {
    let page = data.page;
    let size = data.size;
    return HandleLoading(() =>
      this._instance.get(`/api/story/personal?page=${page}&size=${size}`)
    );
  }

  UpdateStory(data) {
    return HandleLoading(() =>
      this._instance.put(`/api/story/update/${data.id}`, data)
    );
  }

  DeleteStory(id) {
    return HandleLoading(() => this._instance.delete(`/api/story/${id}`));
  }

  GetSingleStory(id) {
    return HandleLoading(() => this._instance.get(`/api/story/single/${id}`));
  }

  GetStoriesStatus() {
    return HandleLoading(() => this._instance.get(`/api/story/status/all`));
  }

  ApplyStory(data) {
    let id = data.id;
    return HandleLoading(() =>
      this._instance.put(`/api/story/apply/${id}`, data)
    );
  }

  GetQuestionnaireStatus(data) {
    return this._instance.post("/api/questionnaire/status", data);
  }

  //backend
  GetBackendAllStories(query) {
    return HandleLoading(() =>
      this._instance.get(`/api/story?${stringify(query)}`)
    );
  }

  getAllStories(query) {
    return HandleLoading(() =>
      this._instance.get(`/api/story/all?${stringify(query)}`)
    );
  }

  // 取得評審故事
  GetJudgeStories(query) {
    return HandleLoading(() =>
      this._instance.get(`/api/story/judge?${querystring.stringify(query)}`)
    );
  }

  getJudgedStories() {
    return HandleLoading(() => this._instance.get(`/api/story/judged`));
  }

  DeleteMultiStories(data) {
    return HandleLoading(() =>
      this._instance.post("/api/story/delete/multiple", data)
    );
  }

  ApplyFailed(data) {
    return HandleLoading(() =>
      this._instance.put(`/api/story/apply_failed/${data.id}`, data.message)
    );
  }

  ApplySuccess(data) {
    return HandleLoading(() =>
      this._instance.put(`/api/story/apply_success/${data.id}`)
    );
  }

  UploadYouTube(data) {
    return HandleLoading(() =>
      this._instance.put(`/api/story/upload/youtube`, data)
    );
  }

  CreateManager(data) {
    return HandleLoading(() =>
      this._instance.post(`/api/auth/create-manager`, data)
    );
  }

  GetAccountList() {
    return HandleLoading(() => this._instance.get(`/api/auth/get-manager`));
  }

  DeleteAccout(id) {
    return HandleLoading(() =>
      this._instance.delete(`/api/auth/delete-manager/${id}`)
    );
  }

  UpdateAccount(data) {
    return HandleLoading(() =>
      this._instance.put(`/api/auth/update-manager/${data.id}`, data)
    );
  }

  JudgeStory(is_submit, data) {
    let storyData = _.cloneDeep(data);
    let id = storyData.id;
    storyData.id = undefined;
    return HandleLoading(() =>
      this._instance.put(
        `/api/story/judge/${id}${is_submit ? `?submit=${is_submit}` : ""}`,
        storyData
      )
    );
  }

  getPosts({ page, size, text, published }) {
    return HandleLoading(() =>
      this._instance.get(
        `/api/billboard?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }`
      )
    );
  }

  getAllPosts() {
    return HandleLoading(() => this._instance.get(`/api/billboard/all`));
  }

  createPost({ page, size, text, published }, data) {
    return HandleLoading(() =>
      this._instance.post(
        `/api/billboard?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }`,
        data
      )
    );
  }

  updatePost({ page, size, text, published }, data) {
    return HandleLoading(() =>
      this._instance.put(
        `/api/billboard/${data.id}?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }`,
        data
      )
    );
  }

  deletePost({ page, size, text, published }, id) {
    return HandleLoading(() =>
      this._instance.delete(
        `/api/billboard/${id}?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }`
      )
    );
  }

  GetUserList({ page, size, text, status }) {
    return HandleLoading(() =>
      this._instance.get(
        `/api/auth/list?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${status ? `&status=${status}` : ""}`
      )
    );
  }

  getAllUsers() {
    return HandleLoading(() => this._instance.get(`/api/auth/all`));
  }

  GetUserInfo(id) {
    return HandleLoading(() => this._instance.get(`/api/auth/user/${id}`));
  }

  GetEduResourceList({ page, size, text, published, step }) {
    return HandleLoading(() =>
      this._instance.get(
        `/api/edu-resource?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }${step ? `&step=${step}` : ""}`
      )
    );
  }

  GetEduResourceDetailLink(link) {
    return HandleLoading(() =>
      this._instance.get(`/api/track/link/users?q=${link}`)
    );
  }

  GetEduResourceDetailUser(account) {
    return HandleLoading(() =>
      this._instance.get(`/api/track/account/links?q=${account}`)
    );
  }

  createEduResource({ page, size, text, published }, data) {
    return HandleLoading(() =>
      this._instance.post(
        `/api/edu-resource?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }`,
        data
      )
    );
  }

  updateEduResource({ page, size, text, published }, data) {
    return HandleLoading(() =>
      this._instance.put(
        `/api/edu-resource/${data.id}?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }`,
        data
      )
    );
  }

  deleteEduResource({ page, size, text, published }, id) {
    return HandleLoading(() =>
      this._instance.delete(
        `/api/edu-resource/${id}?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }`
      )
    );
  }

  GetDFCResourceList({ page, size, text, published }) {
    return HandleLoading(() =>
      this._instance.get(
        `/api/dfc-resource?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }`
      )
    );
  }

  createDFCResource({ page, size, text, published }, data) {
    return HandleLoading(() =>
      this._instance.post(
        `/api/dfc-resource?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }`,
        data
      )
    );
  }

  updateDFCResource({ page, size, text, published }, data) {
    return HandleLoading(() =>
      this._instance.put(
        `/api/dfc-resource/${data.id}?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }`,
        data
      )
    );
  }

  deleteDFCResource({ page, size, text, published }, id) {
    return HandleLoading(() =>
      this._instance.delete(
        `/api/dfc-resource/${id}?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          published ? `&published=${published}` : ""
        }`
      )
    );
  }

  GetDFCResourceDetailLink(link) {
    return HandleLoading(() =>
      this._instance.get(`/api/track/link/users?q=${link}`)
    );
  }

  GetDFCResourceDetailUser(account) {
    return HandleLoading(() =>
      this._instance.get(`/api/track/account/links?q=${account}`)
    );
  }

  GetSchoolList({ page, size, text, activated, category }) {
    return HandleLoading(() =>
      this._instance.get(
        `/api/school?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          activated ? `&activated=${activated}` : ""
        }${category ? `&category=${category}` : ""}`
      )
    );
  }

  createSchool({ page, size, text, activated, category }, data) {
    return HandleLoading(() =>
      this._instance.post(
        `/api/school?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          activated ? `&activated=${activated}` : ""
        }${category ? `&category=${category}` : ""}`,
        data
      )
    );
  }

  updateSchool({ page, size, text, activated, category }, data) {
    return HandleLoading(() =>
      this._instance.put(
        `/api/school/${data.id}?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          activated ? `&activated=${activated}` : ""
        }${category ? `&category=${category}` : ""}`,
        data
      )
    );
  }

  deleteSchool({ page, size, text, activated, category }, id) {
    return HandleLoading(() =>
      this._instance.delete(
        `/api/school/${id}?${page ? `page=${page}` : ""}${
          size ? `&size=${size}` : ""
        }${text ? `&text=${text}` : ""}${
          activated ? `&activated=${activated}` : ""
        }${category ? `&category=${category}` : ""}`
      )
    );
  }

  getNotificationList() {
    return HandleLoading(() => this._instance.get(`/api/notification`));
  }

  getNotification(id) {
    return HandleLoading(() => this._instance.get(`/api/notification/${id}`));
  }

  createNotification(data) {
    return HandleLoading(() => this._instance.post(`/api/notification`, data));
  }

  updateNotification(id, data) {
    return HandleLoading(() =>
      this._instance.put(`/api/notification/${id}`, data)
    );
  }

  deleteNotification(id) {
    return HandleLoading(() =>
      this._instance.delete(`/api/notification/${id}`)
    );
  }

  testNotification(data) {
    return HandleLoading(() =>
      this._instance.post(`/api/notification/test`, data)
    );
  }

  uploadMerryMamaUser(data) {
    return HandleLoading(() =>
      this._instance({
        url: "/api/merrymama-user",
        method: "POST",
        data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    );
  }
  track(link) {
    return `${this._baseURL}/api/track/link?t=${this._token}&q=${link}`;
  }

  // SurveyCake API 整合
  ParseThankYouURL(url) {
    try {
      const urlObj = new URL(url);
      const svid = urlObj.searchParams.get("svid");
      const hash = urlObj.searchParams.get("hash");
      return { svid, hash };
    } catch (error) {
      console.error("解析感謝信URL失敗:", error);
      return { svid: null, hash: null };
    }
  }

  GetSurveyContent(svid, hash) {
    const surveycakeApiUrl = process.env.VUE_APP_SURVEYCAKE_API_URL;

    return HandleLoading(() =>
      axios.get(`${surveycakeApiUrl}/webhook/v0/${svid}/${hash}`, {
        headers: {
          "content-type": "application/json",
          accept: "application/json",
        },
      })
    );
  }

  GetSurveyResponses(svid, hash) {
    const surveycakeApiUrl =
      process.env.VUE_APP_SURVEYCAKE_API_URL || "https://api.surveycake.com";
    const hashKey = process.env.VUE_APP_SURVEYCAKE_HASH_KEY || "";

    return HandleLoading(() =>
      axios.get(`${surveycakeApiUrl}/v1/surveys/${svid}/responses`, {
        headers: {
          Authorization: `Bearer ${hashKey}`,
          "X-Survey-Hash": hash,
          "Content-Type": "application/json",
        },
      })
    );
  }

  ValidateSurveyAccess(svid, hash) {
    // 本地驗證，不需要呼叫外部API
    const SurveyCakeUtils = require("@/libs/surveycake").default;
    const validation = SurveyCakeUtils.parseAndValidateThankYouURL(
      window.location.href
    );

    return Promise.resolve({
      data: {
        success: validation.valid,
        message: validation.valid ? "驗證成功" : validation.error,
        data: {
          svid: validation.svid,
          valid: validation.valid,
        },
      },
    });
  }

  CreateSurveyCakeForm(data) {
    const surveycakeApiUrl =
      process.env.VUE_APP_SURVEYCAKE_API_URL || "https://api.surveycake.com";
    const hashKey = process.env.VUE_APP_SURVEYCAKE_HASH_KEY || "";

    return HandleLoading(() =>
      axios.post(`${surveycakeApiUrl}/v1/surveys`, data, {
        headers: {
          Authorization: `Bearer ${hashKey}`,
          "Content-Type": "application/json",
        },
      })
    );
  }

  SendThankYouMessage(data) {
    const surveycakeApiUrl =
      process.env.VUE_APP_SURVEYCAKE_API_URL || "https://api.surveycake.com";
    const hashKey = process.env.VUE_APP_SURVEYCAKE_HASH_KEY || "";
    const { svid, email, customMessage } = data;

    return HandleLoading(() =>
      axios.post(
        `${surveycakeApiUrl}/v1/surveys/${svid}/thankyou`,
        {
          email: email,
          message: customMessage || "感謝您參與我們的問卷調查！",
        },
        {
          headers: {
            Authorization: `Bearer ${hashKey}`,
            "Content-Type": "application/json",
          },
        }
      )
    );
  }

  GetSurveyCakeStatus(svid) {
    const surveycakeApiUrl =
      process.env.VUE_APP_SURVEYCAKE_API_URL || "https://api.surveycake.com";
    const hashKey = process.env.VUE_APP_SURVEYCAKE_HASH_KEY || "";

    return HandleLoading(() =>
      axios.get(`${surveycakeApiUrl}/v1/surveys/${svid}/status`, {
        headers: {
          Authorization: `Bearer ${hashKey}`,
          "Content-Type": "application/json",
        },
      })
    );
  }

  __getMerryMamaUserList(query) {
    return HandleLoading(() =>
      this._instance({
        url: "/api/merrymama-user?" + querystring.stringify(query),
        method: "GET",
      })
    );
  }

  __deleteMerryMamaUser(id) {
    return HandleLoading(() =>
      this._instance({
        url: "/api/merrymama-user/" + id,
        method: "DELETE",
      })
    );
  }
}

export default new API();
